// Amazon Associates affiliate wiring for book reviews.
//
// We link to a *tagged Amazon search* rather than a fixed product (ASIN): the
// Associates tag sets the 24h tracking cookie, so any qualifying purchase in
// that session still pays out, and we avoid maintaining (and mis-linking) a
// specific edition for 70+ books. The search query is derived from the review
// title, which is written as "Book Title by Author" — an ideal query.
//
// The Operating Agreement requires the earnings disclosure to be displayed
// wherever these links appear; AFFILIATE_DISCLOSURE is rendered in the CTA.

/** Amazon.co.uk Associates store/tracking id. */
export const AMAZON_TAG = 'gazardev-21'
const AMAZON_HOST = 'https://www.amazon.co.uk'

export const AFFILIATE_DISCLOSURE =
  'As an Amazon Associate I earn from qualifying purchases.'

/**
 * Reduce a review title to a clean book-search query: drop a leading
 * "A Review of"/"Review:" and any editorialising tail after a dash
 * ("Bad Blood by John Carreyrou – A Riveting Exposé…" → "Bad Blood by John
 * Carreyrou"). Keeps "Title by Author" / "Title: Subtitle" intact.
 */
export function bookQueryFromTitle(title: string): string {
  return title
    .replace(/^\s*(a\s+)?review\s+(of\s+)?[:-]?\s*/i, '')
    .split(/\s+[–—-]\s+/)[0]
    .replace(/,\s*illustrated by.*$/i, '')
    .trim()
}

/** Tagged Amazon.co.uk search URL for a free-text query. */
export function amazonSearchUrl(query: string): string {
  const params = new URLSearchParams({ k: query, tag: AMAZON_TAG })
  return `${AMAZON_HOST}/s?${params.toString()}`
}

/** Tagged Amazon.co.uk search URL derived straight from a review title. */
export function amazonUrlForReview(title: string): string {
  return amazonSearchUrl(bookQueryFromTitle(title))
}
